var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M3.24078 3.59998H14.7608C15.5528 3.59998 16.2008 4.20748 16.2008 4.94998V13.05C16.2008 13.7925 15.5528 14.4 14.7608 14.4H3.24078C2.44878 14.4 1.80078 13.7925 1.80078 13.05V4.94998C1.80078 4.20748 2.44878 3.59998 3.24078 3.59998Z",
          stroke: "#676060",
          "stroke-width": "1.125",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M16.2008 4.5L9.00078 9.9L1.80078 4.5",
          stroke: "#676060",
          "stroke-width": "1.125",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }